import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker, message, Spin, Flex } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import {
  DownCircleOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { apiRequest } from "../../../utilities/apiMethod";
import { useIrnStore } from "../../../store/useIrnstore";
import CategoryGrid from "./CategoryGrid";
// import StoreGrid from "./CategoryGrid";

export const CategoryForm = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    fetchPeriods();
  }, []);

  const fetchPeriods = async () => {
    try {
      setLoading(true);
      const response = await apiRequest("GET", "Period/getperiods");
      if (response.IsSuccess && response.Data) {
        setPeriods(response.Data);
        const firstPeriod = response.Data[0];
        if (firstPeriod) {
          setSelectedPeriod(firstPeriod.PeriodId);
          if (firstPeriod.PeriodName === "Custom") {
            setFromDate(null);
            setToDate(null);
          } else {
            setFromDate(dayjs(firstPeriod.FromDate));
            setToDate(dayjs(firstPeriod.Todate));
          }
          // Auto-filter with default period
          setTimeout(() => handleFilter(), 100); // Small delay to ensure state updates
        }
        messageApi.success(
          response.DisplayMessage || "Periods loaded successfully"
        );
      } else {
        if (response.ErrorMessage && response.ErrorMessage.length > 0) {
          response.ErrorMessage.forEach((err) => {
            messageApi.error(err);
          });
        } else {
          messageApi.error(response.DisplayMessage || "Failed to load periods");
        }
      }
    } catch (error) {
      console.error("Error fetching periods:", error);
      messageApi.error("An error occurred while fetching periods");
    } finally {
      setLoading(false);
    }
  };

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);
    const selected = periods.find((p) => p.PeriodId === value);

    if (selected) {
      if (selected.PeriodName === "Custom") {
        // For custom, clear dates and let user select
        setFromDate(null);
        setToDate(null);
      } else {
        // Set dates from the selected period
        setFromDate(dayjs(selected.FromDate));
        setToDate(dayjs(selected.Todate));
      }
    }
  };

  const handleFilter = async () => {
    // Validation
    if (!selectedPeriod) {
      messageApi.warning("Please select a period");
      return;
    }

    if (!fromDate || !toDate) {
      messageApi.warning("Please select both From Date and To Date");
      return;
    }

    try {
      setFilterLoading(true);
      const fromDateStr = fromDate.format("YYYY-MM-DD");
      const toDateStr = toDate.format("YYYY-MM-DD");
      const response = await apiRequest(
        "GET",
        `SAPIntegration/getCategory/${fromDateStr}/${toDateStr}`
      );
      if (response.IsSuccess) {
        if (response.Data && response.Data.length > 0) {
          const formatedDATa =response.Data.map((val,index)=>{
            return {
                serialNo:index+1,
                ...val
            }
          })
           setGridData(formatedDATa);
          messageApi.success("Data retrieved successfully");
        } else {
          messageApi.warning(response.DisplayMessage || "No records found");
        }
      } else {
        messageApi.error(response.DisplayMessage || "An error occurred while fetching data");
      }
      //   await getAllPos(fromDateStr, toDateStr);
    } catch (error) {
      console.error("Error fetching category SAP list:", error);
      messageApi.error("An error occurred while fetching data");
    } finally {
      setFilterLoading(false);
    }
  };

  const handleReset = () => {
    setSelectedPeriod(null);
    setFromDate(null);
    setToDate(null);
  };

  const isCustomPeriod = () => {
    const selected = periods.find((p) => p.PeriodId === selectedPeriod);
    return selected && selected.PeriodName === "Custom";
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Flex align="center" gap="middle">
          <Spin size="large" />
        </Flex>
      </div>
    );
  }

  return (
    <>
      {contextHolder}
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Period"} isImportnt={false} />
          <Select
            id="period"
            placeholder="Select Period"
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            value={selectedPeriod}
            onChange={handlePeriodChange}
            options={periods.map((period) => ({
              value: period.PeriodId,
              label: period.PeriodName,
            }))}
          />
        </Col>

        <Col xl={2} md={6}>
          <CustomLabel children={"From Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            size="medium"
            value={fromDate}
            onChange={(date) => setFromDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>

        <Col xl={2} md={6}>
          <CustomLabel children={"To Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            size="medium"
            value={toDate}
            onChange={(date) => setToDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>

        <Col xl={4} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            onClick={handleFilter}
            loading={filterLoading}
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#1aa8c4ff",
              borderColor: "#1a94c4ff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
          >
            Filter
          </Button>

          <Button
            icon={<ReloadOutlined />}
            size="large"
            onClick={handleReset}
            style={{
              marginRight: "0.75rem",
              borderColor: "#ff4d4f",
              color: "#ff4d4f",
            }}
          >
            Reset
          </Button>
        </Col>
      </Row>
      <CategoryGrid data={gridData} />
    </>
  );
};
